import Colors from '@root/brand/src/utils/colors';
import PropTypes from '@root/vendor/prop-types';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';

export default function InputError({ message }) {
  const errorLabelStyles = [styles.errorLabel];

  if (message) {
    errorLabelStyles.push(styles.hasError);
  }

  return (
    <span
      aria-label={message}
      css={errorLabelStyles}
      role={'alert'}
    >
      {message}
    </span>
  );
}

InputError.propTypes = {
  message: PropTypes.string,
};

const styles = StyleSheet.create({
  errorLabel: {
    ...Theme.input(),
    color: Colors.error(),
    opacity: 0,
    transition: 'transform 300ms ease-in, opacity 300ms ease-in',
    transform: 'translateY(-150%)',
  },
  hasError: {
    marginTop: 5,
    opacity: 1,
    transform: 'translateY(0)',
  },
});
